/* @flow */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';
import Icon from 'react-native-vector-icons/FontAwesome';
import dayjs from 'dayjs';

import {
  numberOfItemsWaitingToSyncSelector,
  lastFetchTimeSelector,
} from '../modules/todo/selectors';
import { isConnectedSelector } from '../modules/system/selectors';
import l from '../utils/localization';


const styles = StyleSheet.create({
  wrapper: {
    padding: 10, paddingHorizontal: 20, borderRadius: 40, marginVertical: 10,
  },
  centeredText: { textAlign: 'center', color: 'white' },
});

const SyncIndicator = () => {
  const isConnected = useSelector(isConnectedSelector),
        lastFetchTime = useSelector(lastFetchTimeSelector),
        numberOfItemsWaitingToSync = useSelector(numberOfItemsWaitingToSyncSelector),
        isConnectedIcon = isConnected ? 'cloud' : 'plane',
        isConnectedText = isConnected ? ` ${l.online}` : ` ${l.offlineMode}`,
        isConnectedColor = isConnected
          ? 'darkgreen'
          : 'darkorange';

  return (
    <View style={[styles.wrapper, { backgroundColor: isConnectedColor }]}>
      <Text style={styles.centeredText}>
        <Icon name={isConnectedIcon} />
        {isConnectedText}
      </Text>
      <Text style={[styles.centeredText, { fontSize: 10 }]}>
        <Icon name='refresh' size={10} />
        {numberOfItemsWaitingToSync > 0
          ? ` ${numberOfItemsWaitingToSync} ${l.changesToSync}`
          : lastFetchTime ? ` ${dayjs(lastFetchTime).fromNow()}` : ''}
      </Text>
    </View>
  );
};

export default SyncIndicator;
